<div>
  <img src="/assets/img/locked-image.png" alt="Cintra locked image" style="max-width: 40rem" />
  <p>Environment locked.</p>
  <p>
    Contact the Cintra finance team (<a href="mailto:finance@cintra.co.uk">{{ 'finance@cintra.co.uk' }}</a
    >) for resolution
  </p>
  <p>Thank-you for your co-operation.</p>
</div>
